import * as Constants from "../utils/constants";
import axios from "axios";

export const createChart = async (chartData) => {
  try {
    const response = await axios.post(
      Constants.CHART,
      chartData,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const getCharts = async () => {
  try {
    const resposne = await axios.get(Constants.CHART, Constants.CONFIG);
    return resposne.data;
  } catch (error) {
    return error.message;
  }
};

export const getSpecificChart = async (chartID) => {
  try {
    const response = await axios.get(
      `${Constants.CHART}/${chartID}`,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const deleteChart = async (chartID) => {
  try {
    await axios.delete(`${Constants.CHART}/${chartID}`, Constants.CONFIG);
    return true;
  } catch (error) {
    return error.message;
  }
};

export const updateTheChart = async (chartID, updatedData) => {
  try {
    await axios.put(
      `${Constants.CHART}/${chartID}`,
      updatedData,
      Constants.CONFIG
    );
    return true;
  } catch (error) {
    return error.message;
  }
};
